import { EventAvailable } from "@material-ui/icons";
import ApplicationResource from "../../utils/resources.enum";
import FormsRequestCreate from "./forms-request-create";
import FormsRequestEdit from "./forms-request-edit";
import FormsRequestList from "./forms-request-list";
import FormsRequestShow from "./forms-request-show";

export const formsRequestResource = {
    name: ApplicationResource.FORM_REQUEST,
    icon: EventAvailable,
    options: { label: "Todas Requisições" },
    link: "/formsRequest",
    tableName: 'formsRequest',
    list: FormsRequestList,
    edit: FormsRequestEdit,
    create: FormsRequestCreate,
    show: FormsRequestShow,
    products: ['office', 'forms']
};